// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DigitalPaymentV1ClientGeneratedCounterpartyEntityDetail {
    'counterpartyEntityAliasId'?: string | null;
    'counterpartyEntityName'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalPaymentV1ClientGeneratedCounterpartyEntityDetail>> = [
        {
            "name":     "counterpartyEntityAliasId",
            "baseName": "counterpartyEntityAliasId",
            "type":     "string"
        },
        {
            "name":     "counterpartyEntityName",
            "baseName": "counterpartyEntityName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalPaymentV1ClientGeneratedCounterpartyEntityDetail.attributeTypeMap;
    }
}
